import { render, staticRenderFns } from "./certificate-category-form.vue?vue&type=template&id=1bb2377a&scoped=true&"
import script from "./certificate-category-form.ts?vue&type=script&lang=ts&"
export * from "./certificate-category-form.ts?vue&type=script&lang=ts&"
import style0 from "./certificate-category-form.scss?vue&type=style&index=0&id=1bb2377a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb2377a",
  null
  
)

export default component.exports